var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortugal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2b6519",
    d: "M0 24V0h11v24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea3323",
    d: "M11 24V0h19v24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcc4d",
    d: "M10.5 5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M5.53 8.73l1.3 1.3-2 1q.1-1.22.7-2.3m-.7 3.24 3.58 1.79-2.2 1.47.01.01a5.7 5.7 0 0 1-1.38-3.27m4.86 5.15a6 6 0 0 1-2.1-.75h2.1zm0-1.56H7.17l2.52-1.68zm0-2.65-.5.33-3.47-1.74 1.72-.86 2.25 2.25zm0-1.17L6.8 8.86l2.88.48zm0-3.25-3.6-.58a5.7 5.7 0 0 1 3.6-2.03zm5.78.24q.6 1.08.7 2.3l-2-1zM11.3 5.88c1.42.2 2.7.93 3.6 2.04l-3.6.57zm0 3.46 2.88-.48-2.88 2.88zm0 3.55 2.25-2.25 1.72.86-3.47 1.74-.5-.33zm0 4.23v-.75h2.1a6 6 0 0 1-2.1.75m0-1.56v-1.68l2.52 1.68zm3.47-.32v-.02l-2.19-1.46 3.57-1.8a5.7 5.7 0 0 1-1.38 3.28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "M7 7v5.73C7 14.53 8.57 16 10.5 16s3.5-1.46 3.5-3.27V7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 8v4.67C8 13.96 9.12 15 10.5 15s2.5-1.04 2.5-2.33V8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#829acd",
    d: "M9 11h3v2H9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#829acd",
    d: "M10 10h2v3h-2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#039",
    d: "M8 10.63h.83v1.74H8zm1.67 0h1.66v1.74H9.67zm2.5 0H13v1.74h-.83zm-2.5 2.62h1.66V15H9.67zm0-5.25h1.66v1.75H9.67z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortugal);
export default __webpack_public_path__ + "static/media/portugal.07493a524523dc8dba325a2ba15ef561.svg";
export { ForwardRef as ReactComponent };